import { configurationPageClass } from '@modules/configuration/components/configurationLayout';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@components/ui/button';
import { Spinner } from '@components/ui/Spinner';
import { useWebhookDeliveries } from '../../hooks/useWebhookDeliveries';
import { useWebhookEventTypes } from '../../hooks/useWebhookEndpoints';
import { useWebhookMutations } from '../../hooks/useWebhookMutations';
import { useWebhookEndpoint } from '../../hooks/useWebhookEndpoint';
import { DeliveriesTable } from '../display/DeliveriesTable';

export const DeliveriesView = () => {
  const { t } = useTranslation('webhooksModule');
  const { id: endpointIdParam } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const endpointId = endpointIdParam ? parseInt(endpointIdParam, 10) : null;

  const { endpoint, error: endpointQueryError, isLoading: endpointQueryLoading } = useWebhookEndpoint(endpointId);

  const { data: eventTypesData } = useWebhookEventTypes();
  const deliveriesQuery = useWebhookDeliveries(endpointId);
  const mutations = useWebhookMutations();

  const events = eventTypesData?.data ?? [];

  if (endpointQueryLoading || deliveriesQuery.isLoading) {
    return (
      <div className={`${configurationPageClass} flex items-center justify-center py-16`}>
        <Spinner />
      </div>
    );
  }

  if (!endpointId || endpointQueryError || !endpoint || deliveriesQuery.isError || !deliveriesQuery.data) {
    return (
      <div className={configurationPageClass}>
        <Button variant="ghost" onClick={() => navigate('/configuration/webhooks')}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t('deliveries.back')}
        </Button>
        <p className="text-muted-foreground mt-4">{t('toast.errorGeneric')}</p>
      </div>
    );
  }

  return (
    <div className={configurationPageClass}>
      <DeliveriesTable
        endpoint={endpoint}
        deliveries={deliveriesQuery.data.data ?? []}
        events={events}
        onBack={() => navigate('/configuration/webhooks')}
        onRetry={(deliveryId) => mutations.retryDelivery.mutate(deliveryId)}
        isRetrying={mutations.retryDelivery.isPending}
      />
    </div>
  );
};
